export const DocumentDeleteConfirmationContent = () => (
  <>
    Move document and associated content to trash? It will be deleted after 30
    days.
  </>
);
